// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_kd-1";
export var rowFirst = "_kd-3";
export var rowLast = "_kd-5";
export var rowMiddle = "_kd-4";
export var ticketListScroll = "_kd-2";
export var ticketStack = "_kd-0";